document.addEventListener('DOMContentLoaded', function() {

  const popup = document.getElementById('bridal-popup');
  if (!popup) return;

  const openButtons = document.querySelectorAll('.product-form__submit');
  const closeBtn = popup.querySelector('.bridal-close');
  const overlay = popup.querySelector('.bridal-popup-overlay');
  const submitBtn = document.getElementById('popup-submit');

  // =========================
  // 👉 OPEN POPUP
  // =========================
  openButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();

      popup.classList.add('active');

      // 🔥 LOCK SCROLL
      document.documentElement.classList.add('popup-open');
      document.body.classList.add('popup-open');
    });
  });

  // =========================
  // 👉 CLOSE FUNCTION (REUSABLE)
  // =========================
  function closePopup() {
    popup.classList.remove('active');

    // 🔥 UNLOCK SCROLL
    document.documentElement.classList.remove('popup-open');
    document.body.classList.remove('popup-open');
  }

  // =========================
  // 👉 CLOSE EVENTS
  // =========================
  closeBtn?.addEventListener('click', closePopup);
  overlay?.addEventListener('click', closePopup);

  // =========================
  // 👉 SUBMIT POPUP → ADD TO CART
  // =========================
  submitBtn?.addEventListener('click', function() {

    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    // Remove old properties
    form.querySelectorAll('input[name^="properties"]').forEach(el => el.remove());

    // Collect values
    const fields = {
      "First Name": document.getElementById('popup-first-name')?.value,
      "Last Name": document.getElementById('popup-last-name')?.value,
      "Email": document.getElementById('popup-email')?.value,
      "Phone": document.getElementById('popup-phone')?.value,
      "Bust": document.getElementById('popup-bust')?.value,
      "High Waist": document.getElementById('popup-waist')?.value,
      "Base of neck to floor while wearing your wedding shoes": document.getElementById('popup-length')?.value
    };

    // Validation
    if (!fields["First Name"] || !fields["Last Name"] || !fields["Email"]) {
      alert('Please fill required fields');
      return;
    }

    // Append hidden inputs
    Object.keys(fields).forEach(key => {
      if (fields[key]) {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = `properties[${key}]`;
        hidden.value = fields[key];
        form.appendChild(hidden);
      }
    });

    // Close popup BEFORE submitting
    closePopup();

    // Trigger Shopify theme AJAX
    const event = new Event('submit', { bubbles: true, cancelable: true });
    form.dispatchEvent(event);
  });

});
